module Core {
    export enum NavigationDirection {
        none = 0,
        left,
        right,
        top,
        bottom
    }
}